module.exports = __webpack_public_path__ + "media/images/home/steps/almost_married-c9e11be660d528e5efbbbb51c4648ffd.png";